import { ApiModule } from '~/clientApi/ApiModule';

const MODULE = 'creator-brands';

const creatorBrands = (apiInstance) => new ApiModule(apiInstance, MODULE);

export default creatorBrands;
